import { render, staticRenderFns } from "./LogoUpload.vue?vue&type=template&id=3a032c6b&scoped=true&"
import script from "./LogoUpload.vue?vue&type=script&lang=js&"
export * from "./LogoUpload.vue?vue&type=script&lang=js&"
import style0 from "./LogoUpload.vue?vue&type=style&index=0&id=3a032c6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a032c6b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VBtn,VFileInput})
